import React from 'react';
import {
  ShimmerContainer,
  Shimmer,
  ShimmerAvatar,
  Box,
  ShimmerFooter,
  ShimmerSectionContainer,
  ShimmerSectionItem,
  ShimmerBody,
  ShimmerSectionText,
  ShimmerHeader,
  ShimmerHeaderText,
} from './styles';

export default function Placeholder() {
  return (
    <>
      <ShimmerContainer>
        <ShimmerBody>
          <ShimmerHeader className="shimmer-header">
            <ShimmerHeaderText>
              <Shimmer shimmerWidth={80} shimmerHeight={36} />
              <Shimmer shimmerWidth={90} shimmerHeight={36} />
            </ShimmerHeaderText>
            <ShimmerAvatar shimmerWidth={72} shimmerHeight={72} />
          </ShimmerHeader>
          <Box shimmerWidth="100%" shimmerHeight={2} />
          {Array(4)
            .fill(0)
            .map((_, index) => {
              return (
                <ShimmerSectionContainer key={`shimmer-section-${index}`}>
                  <Shimmer shimmerWidth={70} shimmerHeight={16} />
                  {Array(2)
                    .fill(0)
                    .map((id, subIdx) => (
                      //for placeholder we assume each section has 2 subsections
                      <ShimmerSectionItem key={`shimmer-subsection-${index}-${subIdx}`}>
                        <ShimmerSectionText>
                          <Shimmer shimmerWidth={130} shimmerHeight={24} />
                          <Shimmer shimmerWidth={170} shimmerHeight={20} />
                        </ShimmerSectionText>
                        <ShimmerAvatar shimmerWidth={30} shimmerHeight={30} />
                      </ShimmerSectionItem>
                    ))}
                </ShimmerSectionContainer>
              );
            })}
        </ShimmerBody>
        <ShimmerFooter></ShimmerFooter>
      </ShimmerContainer>
    </>
  );
}
